// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jy-1";
export var messageSideRight = "_jy-2";
export var orderLookupBubbleContainer = "_jy-0";
export var submitButton = "_jy-3";